/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FindHomeHealthPractitionerAssignments200ResponseData } from './FindHomeHealthPractitionerAssignments200ResponseData';
import {
    FindHomeHealthPractitionerAssignments200ResponseDataFromJSON,
    FindHomeHealthPractitionerAssignments200ResponseDataFromJSONTyped,
    FindHomeHealthPractitionerAssignments200ResponseDataToJSON,
    FindHomeHealthPractitionerAssignments200ResponseDataToJSONTyped,
} from './FindHomeHealthPractitionerAssignments200ResponseData';

/**
 * 
 * @export
 * @interface FindHomeHealthPractitionerAssignments200Response
 */
export interface FindHomeHealthPractitionerAssignments200Response {
    /**
     * 
     */
    data: FindHomeHealthPractitionerAssignments200ResponseData;
}

/**
 * Check if a given object implements the FindHomeHealthPractitionerAssignments200Response interface.
 */
export function instanceOfFindHomeHealthPractitionerAssignments200Response(value: object): value is FindHomeHealthPractitionerAssignments200Response {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function FindHomeHealthPractitionerAssignments200ResponseFromJSON(json: any): FindHomeHealthPractitionerAssignments200Response {
    return FindHomeHealthPractitionerAssignments200ResponseFromJSONTyped(json, false);
}

export function FindHomeHealthPractitionerAssignments200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindHomeHealthPractitionerAssignments200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': FindHomeHealthPractitionerAssignments200ResponseDataFromJSON(json['data']),
    };
}

export function FindHomeHealthPractitionerAssignments200ResponseToJSON(json: any): FindHomeHealthPractitionerAssignments200Response {
    return FindHomeHealthPractitionerAssignments200ResponseToJSONTyped(json, false);
}

export function FindHomeHealthPractitionerAssignments200ResponseToJSONTyped(value?: FindHomeHealthPractitionerAssignments200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': FindHomeHealthPractitionerAssignments200ResponseDataToJSON(value['data']),
    };
}

